routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.tracking', {
      url: "tracking/{orderId}",
      template: `<tracking sh-ctrl="shCtrl"></tracking>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/orders/tracking/tracking.confing.js
 **/